import { render, staticRenderFns } from "./ListPagoComponent.vue?vue&type=template&id=591e98cc&scoped=true"
import script from "./ListPagoComponent.vue?vue&type=script&lang=js"
export * from "./ListPagoComponent.vue?vue&type=script&lang=js"
import style0 from "./ListPagoComponent.vue?vue&type=style&index=0&id=591e98cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591e98cc",
  null
  
)

export default component.exports